import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { ArrowLeft, Map as MapIcon } from "lucide-react";

// Two-button bar: left = generic Back (history), right = explicit "Torna alla mappa".
// Kept compact so it doesn't overlap page content on any device.
// `hideMap` lets specific pages (Missione, Chi siamo) suppress the "Torna
// alla mappa" pill when the generic Back is enough — chosen per-page so we
// don't affect the ~15 other pages currently using BackButton.
export default function BackButton({ to, label, className = "", testid = "back-btn", hideBack = false, hideMap = false }) {
  const nav = useNavigate();
  const { t } = useI18n();
  const text = label || t("back") || "Indietro";
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      {!hideBack && (
        <button
          data-testid={testid}
          onClick={() => (to ? nav(to) : nav(-1))}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 px-3 py-1.5 rounded-full hover:bg-slate-100"
        >
          <ArrowLeft size={16} /> {text}
        </button>
      )}
      {!hideMap && (
        <button
          data-testid="back-to-map-btn"
          onClick={() => nav("/map")}
          title={t("back_to_map")}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-800 hover:text-emerald-900 px-3 py-1.5 rounded-full bg-emerald-50 hover:bg-emerald-100 border border-emerald-200"
        >
          <MapIcon size={14} /> {t("back_to_map")}
        </button>
      )}
    </div>
  );
}
